import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatIDR } from "@/lib/api";
import { useAppText } from "@/contexts/AppTextContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";
const toAbsUrl = (url) => url && !url.startsWith("http") ? `${BACKEND_URL}${url}` : url;

export default function Catalog() {
  const { t } = useAppText();
  const [courses, setCourses] = useState([]);
  const [enrolledIds, setEnrolledIds] = useState(new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const [c, e] = await Promise.all([api.get("/courses"), api.get("/me/enrollments")]);
        setCourses(c.data);
        setEnrolledIds(new Set(e.data.map((x) => x.course.course_id)));
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="catalog-page">
      <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-[#1A1422] mb-2">{t("catalog.page_title")}</h1>
      <p className="text-[#5C5868] mb-8">{t("catalog.page_subtitle")}</p>

      {loading ? (
        <div className="text-[#5C5868]">{t("dashboard.loading")}</div>
      ) : courses.length === 0 ? (
        <div className="card-surface p-10 text-center text-[#5C5868]">{t("catalog.empty")}</div>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {courses.map((c) => {
            const enrolled = enrolledIds.has(c.course_id);
            return (
              <div key={c.course_id} className="card-surface overflow-hidden card-hover" data-testid={`catalog-card-${c.course_id}`}>
                <Link to={enrolled ? `/courses/${c.course_id}/learn` : `/courses/${c.course_id}`}>
                  <div className="h-44 bg-[#F4F2F8] relative">
                    {c.thumbnail && <img src={toAbsUrl(c.thumbnail)} alt="" className="w-full h-full object-cover" />}
                    <span className="absolute top-3 left-3 bg-black/60 backdrop-blur text-[#FF8C00] text-xs font-semibold px-3 py-1 rounded-full border border-[#FF8C00]/30">
                      {c.category}
                    </span>
                    {enrolled && (
                      <span className="absolute top-3 right-3 bg-[#FF8C00] text-black text-xs font-bold px-3 py-1 rounded-full">
                        {t("catalog.enrolled_badge")}
                      </span>
                    )}
                  </div>
                </Link>
                <div className="p-5">
                  <Link to={enrolled ? `/courses/${c.course_id}/learn` : `/courses/${c.course_id}`}>
                    <h3 className="font-heading font-bold text-[#1A1422] text-lg mb-2 line-clamp-1 hover:text-[#FF8C00]">{c.title}</h3>
                  </Link>
                  <p className="text-sm text-[#5C5868] line-clamp-2 mb-4">{c.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="text-[#FF8C00] font-heading font-bold text-lg">{formatIDR(c.price)}</span>
                    <span className="text-xs text-[#5C5868]">{c.lesson_count} {t("catalog.lessons_suffix")}</span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
